import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { formPrioritiesData } from '../../helpers/formPrioritiesData'

export const getLongPrioritiesInitialData = (
  financialData: IELTFinancialData | null
): string[] | null => {
  if (financialData?.LongTermPriorities) {
    return formPrioritiesData(financialData.LongTermPriorities)
  }
  return null
}
